const DELETE_PARTY = 'DELETE_PARTY';
const CREATE_PARTY = 'CREATE_PARTY';
const SELECT_PARTY = 'SELECT_PARTY';

export default {
    DELETE_PARTY,
    CREATE_PARTY,
    SELECT_PARTY
};
